import styled from '@emotion/styled';

const CONTENT_MAX_WIDTH = 1144;

export const ContentWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 4 })`
    margin: 0 auto;
    max-width: ${CONTENT_MAX_WIDTH}px;
  `}
  ${({ theme }) => theme.media.showAt({ at: 3 })`
    max-width: 864px;
    margin: 0 auto;
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: 0 ${theme.spacing(3)};
  `}
`;
